const i = {
  Billing: "BILLING",
  Shipping: "SHIPPING",
  Mailing: "MAILING",
  Tax: "TAX",
  BillingCheckout: "BILLING_CHECKOUT"
};
export {
  i as o
};
//# sourceMappingURL=ContactType-9a05b343.mjs.map
